import * as __glob_0 from './../aeo-hero-grid.js';
import * as __glob_1 from './../aeo-key-data.js';
import * as __glob_2 from './../bars-graph-slider.js';
import * as __glob_3 from './../bottom-hero-nav.js';
import * as __glob_4 from './../chaptersection.js';
import * as __glob_5 from './../content.webgl.js';
import * as __glob_6 from './../cycle.ts';
import * as __glob_7 from './../draggable.js';
import * as __glob_8 from './../form.ts';
import * as __glob_9 from './../formgate.ts';
import * as __glob_10 from './../highlighted-text.js';
import * as __glob_11 from './../horizontal-bars.js';
import * as __glob_12 from './../ilya.js';
import * as __glob_13 from './../key-data-points.js';
import * as __glob_14 from './../nav.ts';
import * as __glob_15 from './../rive.js';
import * as __glob_16 from './../split.ts';
import * as __glob_17 from './../test.ts';
import * as __glob_18 from './../text-counter.js';
import * as __glob_19 from './../vertical-bars.js';
import * as __glob_20 from './../webgl-receiver.js';
import * as __glob_21 from './../webgl.js';
const modules = { "./../aeo-hero-grid.js": __glob_0, "./../aeo-key-data.js": __glob_1, "./../bars-graph-slider.js": __glob_2, "./../bottom-hero-nav.js": __glob_3, "./../chaptersection.js": __glob_4, "./../content.webgl.js": __glob_5, "./../cycle.ts": __glob_6, "./../draggable.js": __glob_7, "./../form.ts": __glob_8, "./../formgate.ts": __glob_9, "./../highlighted-text.js": __glob_10, "./../horizontal-bars.js": __glob_11, "./../ilya.js": __glob_12, "./../key-data-points.js": __glob_13, "./../nav.ts": __glob_14, "./../rive.js": __glob_15, "./../split.ts": __glob_16, "./../test.ts": __glob_17, "./../text-counter.js": __glob_18, "./../vertical-bars.js": __glob_19, "./../webgl-receiver.js": __glob_20, "./../webgl.js": __glob_21 };
// console.log("modules -> []", modules);

// Extend HTMLElement interface to include our custom property
declare global {
  interface HTMLElement {
    _moduleInitialized?: boolean;
  }
}

export function createCycles(dataAttribute = "module") {
  return Array.from(document.querySelectorAll(`[data-${dataAttribute}]`))
    .map((element) => {
      const htmlElement = element as HTMLElement;
      const attributeValue = htmlElement.dataset[dataAttribute];

      // Check if THIS SPECIFIC ELEMENT is already initialized
      if (htmlElement._moduleInitialized) {
        return null; // Skip this specific element
      }

      const modulePath = modules[`./../${attributeValue}.ts`]
        ? `./../${attributeValue}.ts`
        : `./../${attributeValue}.js`;

      if (modules[modulePath]) {
        // Expecting a default export function
        const moduleFn = (
          modules[modulePath] as {
            default: (el: HTMLElement, dataset: DOMStringMap) => any;
          }
        ).default;
        if (typeof moduleFn === "function") {
          try {
            // Mark THIS SPECIFIC ELEMENT as initialized
            htmlElement._moduleInitialized = true;

            return moduleFn(htmlElement, htmlElement.dataset);
          } catch (error) {
            // Remove the flag if initialization fails
            delete htmlElement._moduleInitialized;
            console.warn(
              `Failed to call default function for ${dataAttribute} "${attributeValue}":`,
              error
            );
            return null;
          }
        } else {
          console.warn(
            `Default export is not a function for ${dataAttribute} "${attributeValue}"`
          );
          return null;
        }
      } else {
        console.warn(`${dataAttribute} not found: "${attributeValue}"`);
        return null;
      }
    })
    .filter((item) => item !== null);
}

// Optional: Helper function to manually clear initialization for testing
export function clearModuleInitialization(element: HTMLElement) {
  delete element._moduleInitialized;
}
